<template>
<div class="z-input-in-block">
  <slot name="icon"></slot>
  <template v-if="type !== 'textarea'">
    <input class="z-input" :class="[size ? 'z-input-' + size : '',{'is-disabled': disabled}]" :type="type" :name="name" :placeholder="placeholder" :disabled="disabled" :readonly="readonly" :maxlength="maxlength" :minlength="minlength" :autocomplete="autoComplete" :autofocus="autofocus" :min="min" :max="max" :form="form" :value="value" @input="handleInput" @focus="handleFocus" @blur="handleBlur" @keyup.enter="handleEnter">
    </template>
    <template v-else>
      <textarea class="z-textarea" :class="[size ? 'z-input-' + size : '',{ 'is-disabled': disabled }]"
      :value="value" @input="handleInput" ref="textarea" :name="name" :placeholder="placeholder" :disabled="disabled" :readonly="readonly" :rows="rows" :form="form" :autofocus="autofocus"
      :maxlength="maxlength" :minlength="minlength" @focus="handleFocus" @blur="handleBlur"></textarea>
      </template>
</div>
</template>
<script>
export default {
  name: "zInput",
  props: {
    value: [String, Number],
    placeholder: String,
    size: String,
    readonly: Boolean,
    autofocus: Boolean,
    icon: String,
    disabled: Boolean,
    type: {
      type: String,
      default: "text"
    },
    name: String,
    autosize: {
      type: [Boolean, Object],
      default: false
    },
    rows: {
      type: Number,
      default: 2
    },
    autoComplete: {
      type: String,
      default: "off"
    },
    form: String,
    maxlength: Number,
    minlength: Number,
    max: {},
    min: {},
    onIconClick: Function
  },

  methods: {
    handleBlur(event) {
      this.$emit("blur", event);
    },
    handleEnter(event) {
      this.$emit("keyup", event);
    },
    handleFocus(event) {
      this.$emit("focus", event);
    },
    handleInput(event) {
      this.zValue = event.target.value;
    },
    handleIconClick(event) {
      if (this.onIconClick) {
        this.onIconClick(event);
      }
      this.$emit("click", event);
    }
  },
  data() {
    return {
      zValue: this.value
    };
  },
  watch: {
    zValue(val) {
      this.$emit("input", val);
    }
  }
};
</script>

<style>
.z-input-in-block {
  display: inline-block;
  position: relative;
}
.z-input {
  color: #666;
  padding: 0 10px;
  height: 32px;
  line-height: 32px;
  font-size: 14px;
  border: solid 1px #e5e5e5;
  border-radius: 2px;
  box-shadow: inset 0 4px 3px rgba(247, 247, 247, 1);
  transition: border-color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  outline: none;
  vertical-align: middle;
}
.z-textarea {
  display: block;
  resize: vertical;
  padding: 5px 7px;
  line-height: 1.5;
  box-sizing: border-box;
  font-size: 14px;
  color: #1f2d3d;
  background-color: #fff;
  border: solid 1px #e5e5e5;
  background-image: none;
  border-radius: 4px;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  outline: none;
  resize: none;
}
.z-input__icon {
  position: absolute;
  width: 35px;
  height: 100%;
  right: 0;
  top: 0;
  text-align: center;
  color: #bfcbd9;
  transition: all 0.3s;
}
.z-icon-date:before {
  content: "112";
}
.z-input.is-disabled,
.z-input.is-disabled:hover,
.z-input.is-disabled:focus {
  background-color: #eef1f6;
  border-color: #d1dbe5;
  color: #bbb;
  cursor: not-allowed;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
}
.z-input-ok {
  border-color: #4aba7b;
}
.z-input-no {
  border-color: #ba4a52;
}
.z-input:hover,
.z-input:focus,
.z-textarea:hover,
.z-textarea:focus {
  border-color: #fbab00;
  -webkit-box-shadow: inset 0 4px 3px rgba(255, 249, 244, 1);
  -moz-box-shadow: inset 0 4px 3px rgba(255, 249, 244, 1);
  box-shadow: inset 0 4px 3px rgba(255, 249, 244, 1);
}
.z-input-60 {
  width: 60px;
}
.z-input-70 {
  width: 70px;
}
.z-input-80 {
  width: 80px;
}
.z-input-100 {
  width: 100px;
}
.z-input-110 {
  width: 110px;
}
.z-input-130 {
  width: 130px;
}
.z-input-165 {
  width: 165px;
}
.z-input-200 {
  width: 200px;
}
.z-input-240 {
  width: 240px;
}
.z-input-260 {
  width: 260px;
}
.z-input-282 {
  width: 282px;
}
.z-input-360 {
  width: 360px;
}
.z-input-560 {
  width: 560px;
}
.z-input-680 {
  width: 681px;
}
</style>